<div class="modal-header border-bottom-0">
  <h4 class="modal-title body-bold-16 slate-600">
    {{'general.cancel_appointment' | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <app-close-icon></app-close-icon>
  </button>
</div>
<div class="modal-body">
  <div class="form-outline">
    <app-textarea-input
      id="cancellationReason"
      name="cancellationReason"
      [label]="'general.cancellationReason' | translate"
      textareaClass="cancellation-reason"
      [(ngModel)]="cancellationReason">
    </app-textarea-input>
  </div>
</div>
<div class="modal-footer border-top-0">
  <div class="actions m-0 flex">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close click')">
      {{'general.close' | translate}}
    </button>
    <button type="button" class="btn btn-danger" [disabled]="isSaving" (click)="cancel()">
      {{'general.cancel' | translate}}
    </button>
  </div>
</div>
